import { ExpandLess } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';

interface PageSidebarItemProps {
  onClick: () => void;
  label?: string;
  isActive?: boolean;
  count?: number;
  expanded?: boolean;
  nested?: boolean;
  plain?: boolean;
}

export const PageSidebarItem = ({
  onClick,
  label,
  isActive = false,
  count,
  expanded,
  nested = false,
  plain = false,
}: PageSidebarItemProps) => {
  return (
    <Box
      role="button"
      onClick={onClick}
      sx={[
        styles.row,
        styles.clickable,
        isActive && styles.rowSelected,
        nested && styles.nested,
        (!!expanded || !!plain) && styles.rowPlain,
      ]}>
      <Box sx={styles.nameAndCaret}>
        <Typography
          variant="body3SemiBold"
          sx={{ flexGrow: 1, fontSize: nested ? 12.5 : 14 }}>
          {label}
        </Typography>
        {expanded !== undefined && (
          <Box
            sx={{
              display: 'flex',
              width: 40,
              justifyContent: 'center',
            }}>
            <ExpandLess
              fontSize="small"
              sx={{
                transform: expanded ? 'rotate(0deg)' : 'rotate(-180deg)',
                transition: 'transform 0.3s ease',
              }}
            />
          </Box>
        )}
      </Box>
      {count !== undefined && (
        <Box sx={[styles.countPill, isActive && styles.pillSelected]}>
          <Typography variant="caption1">
            {count > 999 ? '1K+' : count}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

const styles = {
  row: {
    display: 'flex',
    alignItems: 'center',
    color: 'primary.main',
    pl: 2,
    pr: 1,
    py: 2.5,
    minHeight: 48,
    transitionProperty: 'background-color, color',
    transitionDuration: '0.1s',
    userSelect: 'none',
    borderBottom: 1,
    borderBottomColor: 'grey75',
  },
  rowSelected: {
    backgroundColor: 'secondary.medium',
    color: 'secondary.main',
    '&:hover': { backgroundColor: 'secondary.medium' },
  },
  rowPlain: {
    borderBottom: 0,
  },
  clickable: {
    cursor: 'pointer',
    '&:hover': { backgroundColor: 'grey50', color: 'secondary.main' },
  },
  countPill: {
    px: 1,
    minWidth: 40,
    borderRadius: 999,
    backgroundColor: 'secondary.medium',
    color: 'primary.main',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  pillSelected: {
    backgroundColor: 'white',
  },
  nameAndCaret: {
    display: 'flex',
    alignItems: 'center',
    gap: 1.25,
    flexGrow: 1,
    minWidth: 0,
  },
  nested: {
    pl: 4.5,
    py: 1.5,
    color: 'text.main',
    borderBottom: 0,
  },
};
